// TODO: remove ts-nocheck and fix warnings and errors on this file
// @ts-nocheck
export function Table({ rows }) {
  const headings = rows[0].cells;
  const rowData = rows.slice(1).map(e => e);

  return (
    <div className="overflow-x-scroll px-2 2xl:overflow-x-hidden">
      <div className="flex flex-col">
        <div className="inline-block py-2">
          <table className="divide-y divide-gray-300 shadow ">
            <thead className="bg-gray-50">
              <tr>
                {headings?.map((heading, index) => (
                  <th
                    key={`th-${index}`}
                    scope="col"
                    className="py-2 !px-4 text-sm font-semibold text-gray-900 "
                  >
                    {heading}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200 bg-white ">
              {rowData.map((row, index) => (
                <tr key={`row-${index}`}>
                  {row.cells.map((cell, idx) => (
                    <td
                      key={`cell-${index}-${idx}`}
                      className="min-w-full border-r !p-2 font-mono text-sm font-medium text-gray-900 "
                    >
                      {cell}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
